<template>
  <section class="admin-panel form">
    <mdb-container>
      <mdb-row>
        <mdb-col md="12">
          <h1 class="text-left">
            <strong>Course</strong>
          </h1>
          <h6 class="mb-5">
            <router-link to="/admin/courses">
              <mdb-icon icon="arrow-left" />Back
            </router-link>| Editing:
            <span class="text-uppercase">{{newOrEditedCourse.name}}</span>
          </h6>

          <form class="mb-5" v-on:submit.prevent>
            <!-- Default input name -->
            <mdb-row>
              <mdb-col md="6">
                <label for="name" class="grey-text">Name (url slug)</label>
                <input
                  required
                  v-model="newOrEditedCourse.name"
                  type="text"
                  id="name"
                  class="form-control"
                />
                <label for="excerpt" class="grey-text">Excerpt</label>
                <textarea
                  v-model="newOrEditedCourse.excerpt"
                  class="form-control"
                  id="excerpt"
                  rows="5"
                ></textarea>
              </mdb-col>
              <mdb-col md="6">
                <label for="image" class="grey-text">Image name</label>
                <input
                  v-model="newOrEditedCourse.image"
                  type="text"
                  id="image"
                  class="form-control"
                />
                <label for="description" class="grey-text">Description</label>
                <textarea
                  v-model="newOrEditedCourse.description"
                  class="form-control"
                  id="description"
                  rows="5"
                ></textarea>
              </mdb-col>
            </mdb-row>
          </form>
        </mdb-col>
      </mdb-row>
      
      <mdb-row>
        <mdb-col md="12">
          <mdb-btn
            @click="addingVideoMode = !addingVideoMode"
            class="btn sm btn-primary outline"
          >Add video</mdb-btn>
          <mdb-btn
            @click="addingCkeditorTextMode = !addingCkeditorTextMode"
            class="btn sm btn-primary outline"
          >Add text</mdb-btn>
          <mdb-btn
            @click="addingCategoryMode = !addingCategoryMode"
            class="btn sm btn-primary outline"
          >Add category</mdb-btn>
          <mdb-btn
            @click="addingSubcategoryMode = !addingSubcategoryMode"
            class="btn sm btn-primary outline"
          >Add subcategory</mdb-btn>
          <transition name="slide-fade">
            <div v-if="addingSubcategoryMode">
              <h5 class="pt-3">Subcategory:</h5>
              <input required v-model="subcategorynametext">
              <mdb-btn
                @click="mthAddSubcategoryToCourse"
                class="btn sm btn-primary"
              >OK</mdb-btn>
              <mdb-btn @click="addingSubcategoryMode = !addingSubcategoryMode" class="btn btn-primary">Close</mdb-btn>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="addingCategoryMode">
              <h5 class="pt-3">Category:</h5>
              <input required v-model="categorynametext">
              <mdb-btn
                @click="mthAddCategoryToCourse"
                class="btn sm btn-primary"
              >OK</mdb-btn>
              <mdb-btn @click="addingCategoryMode = !addingCategoryMode" class="btn btn-primary">Close</mdb-btn>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="addingCkeditorTextMode">
              <h5 class="pt-3">Compose document:</h5>
              <input required v-model="ckeditortitle">
              <textarea required v-model="ckeditortext"></textarea>

              <!--<ckeditor :editor="editor" v-model="ckeditortext" :config="ckeditorconfig" ></ckeditor>-->
              <mdb-btn
                @click="mthAddTextToCourseAndContinue"
                class="btn btn-primary sm"
              >Save & Continue</mdb-btn>
              <mdb-btn @click="mthAddTextToCourseAndClose" class="btn btn-primary sm">Save & Close</mdb-btn>
              <mdb-btn @click="mthOnlyCloseAddingTextToCourse" class="btn btn-primary sm">Close</mdb-btn>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="addingVideoMode">
          <mdb-container>

              <h5 class="pt-3">Choose video to add:</h5>
              <mdb-tbl>
                <tbody>
                  <tr v-for="(v,index) in videos" :key="v.id">
                    <td>
                      <a @click="mthAddVideoToCourse(index)">Choose</a>
                    </td>
                    <td>{{v.id}}</td>
                    <td>{{v.data.name}}</td>
                  </tr>
                </tbody>
              </mdb-tbl>
            </mdb-collapse>
          </mdb-container>
            </div>
          </transition>

          <mdb-tbl class="mt-2">
            <thead class="">
              <tr>
                <th></th>
                <th>Title</th>
                <th>Type</th>
                <th>Remove</th>
                <th>Order</th>
              </tr>
            </thead>
            <draggable v-model="newOrEditedCourse.newOrEditedCourseDetails" tag="tbody">
              <tr v-for="(item,index) in newOrEditedCourse.newOrEditedCourseDetails" :key="index">
                <th scope="row">{{index+1}}</th>
                <td v-if="item.type === 'text'" v-html="item.title"></td>
                <td class="categorycell" v-if="item.type === 'category'">{{item.data}}</td>
                <td class="subcategorycell" v-if="item.type === 'subcategory'">{{item.data}}</td>
                <td v-if="item.type === 'video'">{{item.data.data.name}}</td>
                <td>{{item.type}}</td>
                <td class="narrow" @click="mthDeleteItemFromCourse(index)">
                  <mdb-icon icon="times" />
                </td>
                <td class="narrow">
                  <mdb-icon icon="bars" class="text-grey" />
                </td>
              </tr>
            </draggable>
          </mdb-tbl>
        </mdb-col>
      </mdb-row>

      <mdb-btn
        @click="mthSaveCourse()"
        color="primary"
        class="btn-sm my-4"
        rounded
      >Save</mdb-btn>
      <router-link to="/admin/courses">
        <mdb-btn color="primary" class="btn-sm my-4" rounded>Back to Courses</mdb-btn>
      </router-link>
    </mdb-container>

  </section>
</template>

<script>
import {
  mdbContainer,
  mdbCollapse,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import firebase from "firebase/app";
import { store } from "../store";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ContainerMixin, ElementMixin } from "vue-slicksort";
import SortableList from "./SortableList.vue";
import SortableItem from "./SortableItem.vue";
import draggable from "vuedraggable";

export default {
  name: "AdminCoursesEdit",
  components: {
    ClassicEditor,
    mdbContainer,
    mdbCollapse,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    SortableItem,
    SortableList,
    draggable
  },
  data() {
    return {
      modal: false,
      newOrEditedCourse: {
        name: "",
        image: "",
        excerpt: "",
        description: "",
        newOrEditedCourseDetails: []
      },
      videos: [],
      refvideos: firebase.firestore().collection("videos"),
      editor: ClassicEditor,
      ckeditortitle: "",
      ckeditortext: "",
      categorynametext: "",
      subcategorynametext: "",
      ckeditorconfig: {
        // The configuration of the rich-text editor.
        toolbar: {
          items: [
            "Source",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "undo",
            "redo",
          ]
        }
      },
      addingCkeditorTextMode: false,
      addingVideoMode: false,
      addingCategoryMode: false,
      addingSubcategoryMode: false,
      dragging: false
    };
  },
  methods: {
    mthAddTextToCourseAndContinue() {
      this.mthAddTextToCourse();
    },
    mthAddTextToCourseAndClose() {
      this.mthAddTextToCourse();
      this.mthToggleAddingTextVisibility();
    },
    mthToggleAddingTextVisibility() {
      this.addingCkeditorTextMode = !this.addingCkeditorTextMode;
    },
    mthToggleAddingVideoVisibility() {
      this.addingVideoMode = !this.addingVideoMode;
    },
    mthAddTextToCourse() {
      this.newOrEditedCourse.newOrEditedCourseDetails.push({
        type: "text",
        title: this.ckeditortitle,
        data: this.ckeditortext
      });
    },
    mthAddCategoryToCourse() {
      this.newOrEditedCourse.newOrEditedCourseDetails.push({
        type: "category",
        data: this.categorynametext
      });
      this.addingCategoryMode=!this.addingCategoryMode
    },
    mthAddSubcategoryToCourse() {
      this.newOrEditedCourse.newOrEditedCourseDetails.push({
        type: "subcategory",
        data: this.subcategorynametext
      });
      this.addingSubcategoryMode=!this.addingSubcategoryMode
    },
    mthDeleteItemFromCourse(index) {
      this.newOrEditedCourse.newOrEditedCourseDetails.splice(index, 1);
    },
    mthAddVideoToCourse(index) {
      this.newOrEditedCourse.newOrEditedCourseDetails.push({
        type: "video",
        data: this.videos[index]
      });
      this.mthToggleAddingVideoVisibility()
    },
    mthOnlyCloseAddingTextToCourse() {
      this.mthToggleAddingTextVisibility();
    },
    mthSaveCourse() {
      console.log("save clicked");
      console.log(this.$router.currentRoute.path.includes("add"));
      console.log("courseid=");
      console.log(this.$router.currentRoute.params.courseid);

      if (this.$router.currentRoute.path.includes("add"))
        firebase
          .firestore()
          .collection("courses")
          .add(this.newOrEditedCourse);

      if (
        this.$router.currentRoute.path.includes("edit") &&
        this.$router.currentRoute.params.courseid != null
      ) {
        firebase
          .firestore()
          .collection("courses")
          .doc(this.$router.currentRoute.params.courseid)
          .update(this.newOrEditedCourse);
      }
    }
  },
  created() {
    console.log("created courseid=");
    console.log(this.$router.currentRoute.params.courseid);

    if (this.$router.currentRoute.params.courseid)
      firebase
        .firestore()
        .collection("courses")
        .doc(this.$router.currentRoute.params.courseid)
        .get()
        .then(result => {
          this.newOrEditedCourse = result.data();
        });

    this.refvideos.onSnapshot(querySnapshot => {
      //console.log("onsnapshot fired");
      this.videos = [];
      var lp = 0;
      querySnapshot.forEach(doc => {
        lp++;
        this.videos.push({
          id: doc.id,
          data: doc.data()
        });
      });
      //console.log(this.videos);
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.9s ease;
}
.slide-fade-leave-active {
  transition: all 0.9s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.narrow {
  width: 130px;
}

.categorycell
{
  font-weight: bold;
}

.subcategorycell
{
  font-weight: bold;
  color: gray;
}


</style>
